import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/store/redux';

type ConditionOption = {
  [name: string]: boolean | string | number;
};

export type TradeInConditionState = {
  [name: string]: boolean | string | number | null;
};

const initialState: TradeInConditionState = {};

/**
 * Saves the condition form state
 */
const slice = createSlice({
  name: 'tradein/condition',
  initialState,
  reducers: {
    // Select an item for condition
    selectConditionFormOption(state, action: PayloadAction<ConditionOption>) {
      const payload = action.payload;
      return {
        ...state,
        ...payload,
      };
    },
    resetConditionForm() {
      return initialState;
    },
  },
});

export const { selectConditionFormOption, resetConditionForm } = slice.actions;

export const getTradeInConditionState = (
  state: RootState
): TradeInConditionState => state.pages.tradeIn.condition;

export default slice.reducer;
